import { useLayoutContext } from '@srcDS/provider/layout/LayoutContext';
import { useNostoContext } from '@srcDS/provider/nosto/NostoContext';
import { sdk } from '../../../../../../sdk';

export const useSearchProductsApi = () => {
  const { getSearchSessionParams } = useNostoContext();
  const { setIsLoadingSearch, setIsLoadedSearch } = useLayoutContext();

  const getSearchResults = async (searchTerm: string) => {
    if (!searchTerm) {
      setIsLoadedSearch(false);
      return;
    }

    setIsLoadingSearch(true);

    try {
      const sessionParams = await getSearchSessionParams();
      const response = await sdk.callAction({
        actionName: '/apg-search/getProducts',
        payload: { searchTerm, sessionParams },
      });

      if (response.isError) {
        console.error('Search API error: Failed to fetch search results.');
        return;
      }

      setIsLoadedSearch(true);
      // @ts-ignore
      return response?.data;
    } catch (error) {
      console.error('Failed to fetch search results:', error);
      throw new Error(`Search API error: ${error?.message || 'Unknown error'}`);
    } finally {
      setIsLoadingSearch(false);
    }
  };

  return { getSearchResults };
};
